import Vue from 'vue';

import {
  NOTIFICATIONS_GET,
  NOTIFICATIONS_FILTERS_SET,
  NOTIFICATIONS_META_SET,
} from '../mutations-types'
import _ from "lodash";

const state = {
  notifications: null,
  notificationsFilters: null,
  notificationsMeta: {
    pageId: 1,
    perPage: 10,
    meta: null
  }
};

const getters = {
  notifications: state => state.notifications,
  notificationsFilters: state => state.notificationsFilters,
  notificationsMeta: state => state.notificationsMeta,
};

const mutations = {
  [NOTIFICATIONS_GET](state, notifications) {
    Vue.set(state, 'notifications', notifications.data);

    let notificationsMeta = Object.assign(state.notificationsMeta, {
      meta: notifications.meta,
      links: notifications.links
    })
    Vue.set(state, 'notificationsMeta', notificationsMeta);
  },

  [NOTIFICATIONS_FILTERS_SET](state, filters) {
    Vue.set(state, 'notificationsFilters', filters);
  },

  [NOTIFICATIONS_META_SET](state, data) {
    Vue.set(state, 'notificationsMeta', data);
  },
};

const actions = {
  /**
   * @URLParams
   * none
   * @BodyParams
   * listing_id:         integer, required
   * content:            string
   * date:               date, required
   * status:             integer, required
   * listingFullAddress: string, required
   * priority:           integer, required
   * action:             string, required
   * **/
  NOTIFICATIONS_CREATE_REQUEST_SET ({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/notification', data)
        .then(() => {
          resolve();
        }).catch(error => {
          reject();
        });
    });
  },

  /**
   * @URLParams
   * search:   string
   * type:     string, required
   * page:     integer, required
   * per_page: integer, required
   * @BodyParams
   * none
   * **/

  NOTIFICATIONS_REQUEST_GET ({ state, commit }) {
    let requestData = _.assign({}, state.notificationsFilters, {
      page: state.notificationsMeta.pageId,
      per_page: state.notificationsMeta.perPage
    });

    return new Promise((resolve, reject) => {
      Vue.axios.get('/notification',{params: requestData})
        .then(response => {
          commit(NOTIFICATIONS_GET, response.data);
          resolve();
        }).catch(error => {
        reject();
      });
    });
  },

  /**
   * @URLParams
   * none
   * @BodyParams
   * date: date, required
   * **/
  NOTIFICATIONS_UPDATE_REQUEST_PUT ({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      Vue.axios.put('/notification/' + data.id, data.payload)
        .then(() => {
          resolve();
        }).catch(error => {
        reject();
      });
    })
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};